import { TextSearchFilterDTO } from "@landtechnologies/dtos";

export enum TextFilterMust {
  EQUAL = "EQUAL",
  CONTAIN = "CONTAIN",
  NOT_CONTAIN = "NOT_CONTAIN",
}

export type ITextSearchFilter = Omit<TextSearchFilterDTO, "must"> & {
  type: "text";
  must: TextFilterMust;
  mustOptions: TextFilterMust[];
};
